import React, {Component} from 'react';
import toastr from "toastr";

// import ReactGA from "react-ga";
import * as authService from '../../services/authService';
import { getJwt } from '../../services/authService';
import http from '../../services/httpService';
import InputRegular from '../common/InputRegular';
import { Callout, Intent } from '@blueprintjs/core';

class RedeemCode extends Component {
    constructor(props) {
        super(props);

        this.state = {
            discountCode: '',
            setFieldsCheckActive: false,
            couponLoader: false,
            numberOfSmsRemaining: 'no',
            couponImplemented: false,
            errorMessage: ''
        }
    }

    componentDidMount() {
       // ReactGA.pageview(window.location.pathname + window.location.search);
        this.getNumberOfSmsRemaining()
    }

    componentDidUpdate() {
        if(this.state.numberOfSmsRemaining === 'no'){
            this.getNumberOfSmsRemaining();
        }
    }

    getNumberOfSmsRemaining = () => {
        if(this.props.selectedSourceNode && this.props.selectedSourceNode.platforms && this.props.selectedSourceNode.platforms.length){
            let numberOfSmsRemaining = 0;
            this.props.selectedSourceNode.platforms.map(platform=> platform.platform === 'sms' ?
                numberOfSmsRemaining = platform.free_messages_remaining : ''
            )
            this.setState({numberOfSmsRemaining})
        }
    }

    stringToNormalCase = (string) =>{
        let smallCase = string.toLowerCase();
        return smallCase.replace(/^.{1}/g, smallCase[0].toUpperCase());
    }

    handleApplyCoupon = async (e) => {
        e.preventDefault();
        let userId = await this.props.user.id;
        let projectId = await this.props.selectedSource || localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        this.setState({couponLoader: true, couponImplemented: false})
        if(this.props.user && !this.props.user.customer){
            try{
                const stripeResult = await http.post('api/user/' + userId + '/project/' + projectId + '/customers/create_customer',{}, {headers: {authorization: getJwt()}})
            }catch{
                toastr.error("Stripe Customer wasn't created, please try again")
            }
        }
        try{
            const paymentIntentResult = await http.post('api/user/' + userId + '/project/' + projectId + '/customers/switch_to_lifetime_code',  {
                plans_code: this.state.discountCode
            } , {headers: {authorization: getJwt()}});
            if(paymentIntentResult.data.error){
                await this.setState({fieldsCheckActive: true, couponLoader: false, errorMessage: this.stringToNormalCase(paymentIntentResult.data.error)})
            }else{
                await this.setState({couponLoader: false, couponImplemented: true})
                await this.props.updateUserFromServer();
                await this.getNumberOfSmsRemaining();
            }

            // console.log('paymentIntent result: ', paymentIntentResult)
        }catch{
            toastr.error("There was an error while redeeming your code. Please reach out to support@emitto.io and we'll help you get this sorted out. No worries, your codes are safe. :)")
            await this.setState({couponLoader: false})
        }
    }

    render() {
        let isMartech = this.props.selectedSourceNode && this.props.selectedSourceNode.plan &&
        this.props.selectedSourceNode.plan.plan_id && this.props.selectedSourceNode.plan.plan_id.includes('martech') ? true : false;

        if (!this.props.selectedSource) {
            return <React.Fragment>
                <h1 className='main-title'>Redeem Code</h1>
                <div className="row">
                    <div className="col-xs-12 text-center no-feeds-containers">
                        <div className="feed-msg">
                            <img className='emitto-mark' src="/img/emitto-mark.png" alt="Emitto Mark"/>
                            <p className="text-center ">{authService.getCurrentUserName()}</p>
                            <img className='cat-img' src="/img/cat-transparent.gif" alt="No Workspaces"/><p>It looks like you haven't set up any workspaces yet.
                            Add your first workspace so you can redeem your codes.</p>
                        </div>
                        <button className='btn-m btn-action' onClick={this.props.addSource} type="button">
                            Create your first workspace
                        </button>
                    </div>
                </div>
            </React.Fragment>
        } else {
            return (
                <React.Fragment>
                    <h1 className='main-title'>Redeem Code</h1>

                    {/*<p className="nav-back" onClick={() => this.props.history.push('campaigns')}><i*/ }
                    {/*    className="fas fa-chevron-left"></i> New Campaign</p>*/ }

                    <div className="fb-message-wrapper url-shortener-wrapper panel-container">
                        <div className="flex-row-wrapper">
                            <div className="redeem-element-container">
                                <h3>CURRENT PLAN</h3>
                                <div className="redeem-data-container">
                                    <h2 className="blue">{ this.props.selectedSourceNode && this.props.selectedSourceNode.plan ?
                                        this.props.selectedSourceNode.plan.name : '' }</h2>
                                    <p>{ isMartech ? 'Lifetime' : this.props.selectedSourceNode && this.props.selectedSourceNode.plan &&
                                    this.props.selectedSourceNode.plan.interval === 'month' ?
                                        'Monthly plan' : 'Yearly plan' }</p>
                                </div>
                            </div>
                            <div className="redeem-element-container">
                                <h3>FREE SMS</h3>
                                <div className="redeem-data-container">
                                    <h2 className="green">{ this.state.numberOfSmsRemaining === 'no' ? 0 : this.state.numberOfSmsRemaining }</h2>
                                    <p>SMS Available</p>
                                </div>
                            </div>
                            <div className="redeem-element-container">
                                <p>Redeem Code</p>
                                <div className='coupon-container'>
                                    <InputRegular
                                        id={ '1' }
                                        label1=""
                                        label2=""
                                        placeholder="REDEEM_CODE"
                                        type='always-error'
                                        onChange={ async(value) => this.setState({
                                            discountCode: value,
                                            fieldsCheckActive: false
                                        }) }
                                        value={ this.state.discountCode }
                                        required={ true }
                                        fieldsCheckActive={ this.state.fieldsCheckActive }
                                        updateErrorsList={ this.updateErrorsList }
                                        errorMessage={ this.state.errorMessage || "Wrong redeem code. Please add a valid redeem code value!" }
                                    />
                                    { this.state.couponLoader ?
                                        <button className='btn-action spinner' disabled={ true }>Redeem <i className='fa fa-spin fa-spinner'></i>
                                        </button>
                                        :
                                        <button disabled={ !this.state.discountCode } className='btn-action' onClick={ this.handleApplyCoupon }>Redeem</button>
                                    }
                                </div>
                                {
                                    this.state.couponImplemented ?
                                        <Callout icon='tick' intent={ Intent.SUCCESS }>
                                            Code Redeemed! Your plan has been upgraded.
                                        </Callout>
                                        :
                                        ''
                                }

                            </div>
                        </div>
                    </div>
                </React.Fragment>
            )
        }
    }
}

export default RedeemCode;